import { ISuperUserDto } from "../models/SuperUserDto";
import { IUserDetailsDto, UserDetails } from "../models/UserDetailsDto";
import { IUserDto, UserDto } from "../models/UserDto";
import { sessionStorageInstance } from "../services/storage/Storage";
import _ from 'lodash';
import { IUsersDto } from "../models/UsersDto";
import { IDeveloperDto } from "../models/DeveloperDto";
import { IDevelopersDto } from "../models/DevelopersDto";

export class UserUtils {
    public static mapSuperUserToUserDto(superUser: ISuperUserDto): IUserDto {
        let userDto = new UserDto(
            superUser.contractCode, "Amministratore", superUser.email, superUser.name, superUser.surname,
            "AMMINISTRATORE", superUser.username, superUser.terminalInfo
        );
        return userDto;
    }

    public static mapSuperUserToUserDetailsDto(superUser: ISuperUserDto): IUserDetailsDto {
        let userDto = new UserDetails(superUser.contractCode!, superUser.email, superUser.name, superUser.surname, superUser.username, superUser.terminalInfo, "", "AMMINISTRATORE", "Amministratore");
        return userDto;
    }

    public static cacheUsers(userDto: IUsersDto) {
        console.log("[UserUtils] Cache users");
        let usernames: string[] = [];
        if (userDto !== undefined && userDto.users !== undefined && userDto.users.length > 0) {
            _.forEach(userDto.users, (value: IUserDto) => {
                usernames.push(value.username);
            });
        }

        sessionStorageInstance.setData('users', { users: usernames });
    }

    public static cacheDevelopers(developerDto: IDevelopersDto) {
        console.log("[DeveloperUtils] Cache developers");
        let emails: string[] = [];
        if (developerDto !== undefined && developerDto.developers !== undefined && developerDto.developers.length > 0) {
            _.forEach(developerDto.developers, (value: IDeveloperDto) => {
                emails.push(value.email);
            });
        }

        sessionStorageInstance.setData('developers', { developers: emails });
    }

    public static getCachedUsers(): string[] {
        let users: string[] = [];
        if (sessionStorageInstance.hasKey('user')) {
            let user = JSON.parse(sessionStorageInstance.getData('user')!);
            if (user !== undefined) {
                users.push(user.username);
            }
        }

        if (sessionStorageInstance.hasKey('users')) {
            let cached = JSON.parse(sessionStorageInstance.getData('users')!);
            users.push(...cached.users);
        }

        console.log("[UserUtils] Cached: " + users);
        return users;
    }

    public static getCachedDevelopers(): string[] {
        let developers: string[] = [];
        if (sessionStorageInstance.hasKey('developer')) {
            let developer = JSON.parse(sessionStorageInstance.getData('developer')!);
            if (developer !== undefined) {
                developers.push(developer.email);
            }
        }

        if (sessionStorageInstance.hasKey('developers')) {
            let cached = JSON.parse(sessionStorageInstance.getData('developers')!);
            developers.push(...cached.developers);
        }

        console.log("[UserUtils] Cached: " + developers);
        return developers;
    }
}